(function () {
    /* ============================================================
       MULTI-CURRENCY — zero-lag, no apps, no external APIs.
       Shopify injects `window.Shopify.currency` on every storefront
       page: { active: "EUR", rate: "0.92" } — the exact live rate
       Shopify Markets uses at checkout. We convert every hardcoded
       price marked with data-usd, so what the visitor sees on the
       landing page always matches what the cart & checkout charge.
       Requires: Shopify admin → Settings → Markets → add markets
       with local currencies (EUR, CAD, AUD, GBP, ...).
       ============================================================ */
    (function convertPrices() {
      var cur = window.Shopify && window.Shopify.currency;
      if (!cur || !cur.active || cur.active === 'USD') return;
      var rate = parseFloat(cur.rate);
      if (!rate || rate <= 0) return;

      var fmtCents, fmtWhole;
      try {
        fmtCents = new Intl.NumberFormat('en', { style: 'currency', currency: cur.active });
        fmtWhole = new Intl.NumberFormat('en', { style: 'currency', currency: cur.active, maximumFractionDigits: 0 });
      } catch (e) { return; }

      document.querySelectorAll('[data-usd]').forEach(function (el) {
        var usd = parseFloat(el.getAttribute('data-usd'));
        if (isNaN(usd)) return;
        var v = usd * rate;
        if (el.getAttribute('data-round') === '1') {
          /* marketing round numbers ($60, $240+) stay round */
          el.textContent = fmtWhole.format(Math.round(v));
        } else {
          /* real prices get .99 psychological rounding, like Markets' own rounding */
          v = Math.max(0.99, Math.ceil(v) - 0.01);
          el.textContent = fmtCents.format(v);
        }
      });
    })();

    /* Color selection — synced across all swatch groups on the page.
       Selecting a color also swaps the hero photo to the matching kit
       and smoothly scrolls it into view. */
    var selectedColor = 'Pink';
    var swatchGroups = document.querySelectorAll('.fk-color-select');

    function swapHeroPhoto(color) {
      var photo = document.getElementById('fk-hero-photo');
      if (!photo) return;
      var src = photo.getAttribute('data-photo-' + color.toLowerCase());
      if (src && src.indexOf('REPLACE_WITH') === -1 && photo.getAttribute('src') !== src) {
        photo.setAttribute('src', src);
      }
      var anchor = document.getElementById('fk-hero-photo-anchor');
      if (anchor) { anchor.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }

    function setActive(color) {
      selectedColor = color;
      swatchGroups.forEach(function (group) {
        group.querySelectorAll('.fk-color-option').forEach(function (btn) {
          btn.classList.toggle('fk-color-option--active', btn.getAttribute('data-color') === color);
        });
      });
      swapHeroPhoto(color);
    }
    swatchGroups.forEach(function (group) {
      group.querySelectorAll('.fk-color-option').forEach(function (btn) {
        btn.addEventListener('click', function () { setActive(btn.getAttribute('data-color')); });
      });
    });

    /* Add to cart — fixed variant IDs, no product lookup needed */
    var VARIANT_IDS = {
      'Pink': 42912934363232,
      'Black': 42912934396000
    };

    /* The free bonus item ("FORMKIT™ Training Gear") — now has a "Goal"
       variant per option below, chosen via the modal before adding to cart. */
    var GOAL_VARIANT_IDS = {
      'starting': 42928743546976,
      'weight': 42928743579744,
      'glutes': 42928743612512,
      'tone': 42928743645280,
      'core': 42928743678048,
      'posture': 42928743710816,
      'energy': 42928743743584
    };
    var DEFAULT_GOAL_VARIANT_ID = GOAL_VARIANT_IDS.starting;

    /* Refresh the drawer's item list using the theme's OWN method for this —
       confirmed from cart-drawer.liquid, which calls this exact method after
       its own cart changes (e.g. removing a bundle item). This is the real
       fix for the drawer showing stale/empty content. */
    function refreshDrawerItems() {
      try {
        var cartDrawer = document.querySelector('cart-drawer');
        var cartDrawerItems = document.querySelector('cart-drawer-items');
        if (cartDrawerItems && typeof cartDrawerItems.updateCart === 'function') {
          cartDrawerItems.updateCart();
        }
        if (cartDrawer) { cartDrawer.classList.remove('is-empty'); }
        if (cartDrawerItems) { cartDrawerItems.classList.remove('is-empty'); }
      } catch (err) {
        console.warn('FormKit: could not refresh drawer items (item is still in the cart):', err);
      }
    }

    /* Open the theme's cart drawer by simulating a click on the real header
       cart icon — since that already works correctly on its own, this is
       far more reliable than us trying to call the theme's internal
       rendering methods directly. */
    function openThemeCart() {
      try {
        var cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon) { cartIcon.click(); }
      } catch (err) {
        console.warn('FormKit: could not auto-open the cart drawer (item is still in the cart):', err);
      }
    }

    /* Actually add both items to the cart once we know which goal variant
       to use for the free bonus item. */
    function performAddToCart(btn, goalVariantId) {
      var variantId = VARIANT_IDS[selectedColor];
      var label = btn.querySelector('.fk-btn__label');
      var originalText = label.textContent;

      if (!variantId) {
        label.textContent = 'Select a color';
        setTimeout(function () { label.textContent = originalText; }, 2000);
        return;
      }

      btn.classList.add('fk-loading');
      label.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: variantId, quantity: 1 },
            { id: goalVariantId, quantity: 1, properties: { '_gift': 'true' } }
          ]
        })
      })
        .then(function (res) { if (!res.ok) { throw new Error('Add to cart failed'); } return res.json(); })
        .then(function () {
          btn.classList.remove('fk-loading');
          btn.classList.add('fk-added');
          label.textContent = 'Added';
          setTimeout(function () { btn.classList.remove('fk-added'); label.textContent = originalText; }, 1800);
          refreshDrawerItems();
          openThemeCart();
        })
        .catch(function () {
          btn.classList.remove('fk-loading');
          label.textContent = 'Try again';
          setTimeout(function () { label.textContent = originalText; }, 1800);
        });
    }

    /* Goal modal — shown before every add-to-cart click. Never blocks the
       purchase: a skip option is always available and defaults to the
       general "just starting" plan. */
    var goalModal = document.getElementById('fk-goal-modal');
    var pendingButton = null;

    function openGoalModal(btn) {
      pendingButton = btn;
      if (goalModal) { goalModal.classList.add('fk-goal-modal--open'); }
    }
    function closeGoalModal() {
      if (goalModal) { goalModal.classList.remove('fk-goal-modal--open'); }
    }

    if (goalModal) {
      goalModal.querySelectorAll('.fk-goal-modal__option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var goal = opt.getAttribute('data-goal');
          var goalVariantId = GOAL_VARIANT_IDS[goal] || DEFAULT_GOAL_VARIANT_ID;
          closeGoalModal();
          if (pendingButton) { performAddToCart(pendingButton, goalVariantId); }
        });
      });
      var skipBtn = document.getElementById('fk-goal-modal-skip');
      if (skipBtn) {
        skipBtn.addEventListener('click', function () {
          closeGoalModal();
          if (pendingButton) { performAddToCart(pendingButton, DEFAULT_GOAL_VARIANT_ID); }
        });
      }
      var closeBtn = document.getElementById('fk-goal-modal-close');
      if (closeBtn) { closeBtn.addEventListener('click', closeGoalModal); }
      goalModal.addEventListener('click', function (e) {
        if (e.target === goalModal) closeGoalModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeGoalModal();
      });
    }

    var buttons = document.querySelectorAll('.fk-add-to-cart');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('fk-loading') || btn.classList.contains('fk-added')) return;
        if (!VARIANT_IDS[selectedColor]) {
          var label = btn.querySelector('.fk-btn__label');
          var originalText = label.textContent;
          label.textContent = 'Select a color';
          setTimeout(function () { label.textContent = originalText; }, 2000);
          return;
        }
        openGoalModal(btn);
      });
    });

    /* Offer countdown — resets every 4 hours to keep the launch offer feeling live */
    var countdownEl = document.getElementById('fk-offer-countdown');
    if (countdownEl) {
      var hrsEl = countdownEl.querySelector('[data-unit="hrs"]');
      var minsEl = countdownEl.querySelector('[data-unit="mins"]');
      var secsEl = countdownEl.querySelector('[data-unit="secs"]');
      var CD_KEY = 'fk_offer_countdown_deadline';
      var CD_DURATION = 4 * 60 * 60 * 1000;
      var cdDeadline = Number(localStorage.getItem(CD_KEY));
      if (!cdDeadline || Date.now() > cdDeadline) {
        cdDeadline = Date.now() + CD_DURATION;
        localStorage.setItem(CD_KEY, String(cdDeadline));
      }
      function pad2(n) { return String(n).padStart(2, '0'); }
      function tickCountdown() {
        var diff = Math.max(0, cdDeadline - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (hrsEl) hrsEl.textContent = pad2(h);
        if (minsEl) minsEl.textContent = pad2(m);
        if (secsEl) secsEl.textContent = pad2(s);
        if (diff <= 0) {
          cdDeadline = Date.now() + CD_DURATION;
          localStorage.setItem(CD_KEY, String(cdDeadline));
        }
      }
      tickCountdown();
      setInterval(tickCountdown, 1000);
    }

    /* TikTok-style video row — videos autoplay muted; tapping one toggles
       its sound on/off (and mutes the rest, so only one plays audio at a time) */
    var videoThumbs = document.querySelectorAll('.fk-video-thumb');
    videoThumbs.forEach(function (thumb) {
      var vid = thumb.querySelector('.fk-video-thumb__video');
      if (!vid) return;
      thumb.addEventListener('click', function () {
        var willUnmute = thumb.classList.contains('fk-video-thumb--muted');
        videoThumbs.forEach(function (other) {
          var otherVid = other.querySelector('.fk-video-thumb__video');
          other.classList.add('fk-video-thumb--muted');
          if (otherVid) otherVid.muted = true;
        });
        if (willUnmute) {
          thumb.classList.remove('fk-video-thumb--muted');
          vid.muted = false;
          vid.play().catch(function () {});
        }
      });
    });
  })();